export default {
  list: [
    {"value": 0, "text": "利用停止"},
    {"value": 1, "text": "利用可"},
  ],
  disabled: 0,
  enabled: 1,
};
